// PWA ホーム画面追加バナー。
//
// 表示条件:
//   - 未インストール (isStandalone === false)
//   - 未 dismiss (last-visit ロジックでリセット済みかも)
//   - iOS なら案内文のみ、Android は beforeinstallprompt を保管済みのときだけ表示

import { useInstallPrompt } from '../lib/installPrompt.js';

export function InstallBanner(): JSX.Element | null {
  const { platform, isInstalled, isDismissed, canPrompt, promptInstall, dismiss } =
    useInstallPrompt();

  if (isInstalled || isDismissed) return null;
  if (platform === 'other') return null;
  // Android で beforeinstallprompt が来ていない時は出さない（ブラウザが表示判定中、
  // すでに別経由でインストール済み、エンゲージメント条件未達 等）
  if (platform === 'android' && !canPrompt) return null;

  return (
    <section
      role="region"
      aria-label="ホーム画面に追加の案内"
      className="rounded bg-sky-900/40 border border-sky-700/50 p-4 flex flex-col sm:flex-row sm:items-center gap-3"
    >
      <div className="flex-1">
        <div className="font-bold text-slate-100">📲 ホーム画面に追加すると快適です</div>
        <div className="text-xs text-slate-300 mt-1 leading-relaxed">
          {platform === 'ios'
            ? 'Safari の共有ボタン（□↑）→「ホーム画面に追加」でアプリのように使えます。オフラインでも動作します。'
            : 'インストールすると全画面表示・高速起動・オフライン動作が有効になります。'}
        </div>
      </div>
      <div className="flex gap-2 sm:flex-shrink-0">
        {platform === 'android' && (
          <button
            type="button"
            onClick={() => void promptInstall()}
            className="px-3 py-1.5 rounded bg-sky-600 hover:bg-sky-500 text-white text-sm font-bold"
          >
            インストール
          </button>
        )}
        <button
          type="button"
          onClick={dismiss}
          className="px-3 py-1.5 rounded bg-slate-700 hover:bg-slate-600 text-slate-200 text-sm"
          aria-label="案内を閉じる"
        >
          閉じる
        </button>
      </div>
    </section>
  );
}
